export default __webpack_public_path__ + "static/media/TX_MC_V1_1.77c15177.png";